var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcOpenInNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.4166667,17.4166667 L4.58333333,17.4166667 L4.58333333,4.58333333 L11,4.58333333 L11,2.75 L4.58333333,2.75 C3.56583333,2.75 2.75,3.575 2.75,4.58333333 L2.75,17.4166667 C2.75,18.425 3.56583333,19.25 4.58333333,19.25 L17.4166667,19.25 C18.425,19.25 19.25,18.425 19.25,17.4166667 L19.25,11 L17.4166667,11 L17.4166667,17.4166667 L17.4166667,17.4166667 Z M12.8333333,2.75 L12.8333333,4.58333333 L16.1241667,4.58333333 L7.11333333,13.5941667 L8.40583333,14.8866667 L17.4166667,5.87583333 L17.4166667,9.16666667 L19.25,9.16666667 L19.25,2.75 L12.8333333,2.75 L12.8333333,2.75 Z",
    id: "qrewrewrqwe2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "qrewrewrqwe",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKKOTTTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2.-Import",
    transform: "translate(-599.000000, -666.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(439.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "select/link-select/default",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icconnnnochka",
    transform: "translate(123.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qrewrewrqwe2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "colllloooor-Color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qrewrewrqwe"
  })), /*#__PURE__*/React.createElement("use", {
    id: "BLACKKKKKKK",
    fill: "#979FA8",
    xlinkHref: "#qrewrewrqwe"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcOpenInNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-open-in-new.217b0acd.svg";
export { ForwardRef as ReactComponent };